import { Box, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Card from "./Card";
import { GetBlogsDetails } from "../../Services/firebase";
import SectionTitle from "../Common/SectionTitle";
import CustomButton from "../Common/CustomButton";
import useCurrentLocation from "../../hooks/useCurrentLocation";
import { useNavigate } from "react-router-dom";
import { CgDetailsMore } from "react-icons/cg";
import { sortBlogsBasedOnOrders } from "../../utils";
import Loader from "../Loader";

const Blogs = () => {
  const { isHomePage } = useCurrentLocation();

  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBlogsData = async () => {
    const result = GetBlogsDetails();
    setLoading(true);
    result
      .then((res) => {
        setLoading(false);
        if (res?.length > 0) {
          const sortedBlogs = sortBlogsBasedOnOrders(res, isHomePage);

          setBlogs(sortedBlogs);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("error:", err);
      });
  };
  useEffect(() => {
    fetchBlogsData();
  }, [isHomePage]);

  return (
    <Box>
      <SectionTitle title="Bytes of Knowledge" />
      <Box>
        {!loading && blogs.length > 0 ? (
          <Box
            display="flex"
            alignItems="center"
            justifyContent={{ base: "center", xxl: "flex-start" }}
            gap={12}
            flexWrap="wrap"
          >
            {blogs.map((blog, idx) => {
              return <Card key={blog.blogId} blog={blog} index={idx} />;
            })}
          </Box>
        ) : (
          <Loader />
        )}
      </Box>
      {isHomePage && (
        <CustomButton
          text="More"
          icon={<CgDetailsMore fontSize="1.5rem" />}
          handleClick={() => {
            navigate("blogs");
          }}
        />
      )}
    </Box>
  );
};

export default Blogs;
